import React, { useEffect, useState } from "react";
import { Button, ButtonToolbar, Loader, Container, Modal } from "rsuite";
import "./Charts.css";
import { useTranslation } from "react-i18next";
import ChartSongs from "./ChartSongs";

const ChartSongsModal = ({
  chartId,
  chartData,
  onDeleteSongs,
  openModal,
  setOpenModal,
  showPlayer = true,
  ...props
}: {
  chartId: number;
  chartData?: any;
  onDeleteSongs?: Function;
  openModal: boolean;
  showPlayer?: boolean;
  setOpenModal: Function;
}) => {
  const { t } = useTranslation();

  const [loader, setLoader] = useState(false);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={openModal}
        backdrop={false}
        onClose={(e: any) => {
          setOpenModal("");
        }}
        size="lg"
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("CHART")} {t("SONGS")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="">
            <ChartSongs
              withHeader={false}
              chartId={chartId}
              chartData={chartData}
              onDeleteSongs={onDeleteSongs}
              enableBulkAction={["delete"]}
              showPlayer={showPlayer}
            />
            <ButtonToolbar className="btn-center">
              <Button
                onClick={(e: any) => setOpenModal("")}
                color="red"
                appearance="primary"
              >
                {t("CLOSE")}
              </Button>
            </ButtonToolbar>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ChartSongsModal;
